'use client';

import { useEffect } from 'react';

export const CookieBannerScript = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://consent.cookiebot.com/uc.js';
      script.setAttribute('data-cbid', 'f680979f-7825-4589-a491-daaecf900f25');
      script.setAttribute('data-blockingmode', 'auto');
      script.setAttribute(
        'data-georegions',
        "{'region':'US-06','cbid':'531eb1d9-32f0-48a1-a1c9-b23feed83304'}"
      );
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  return <></>;
};
